import React from 'react';
import './MultiColumnSection.css';

const MultiColumnSection = ({ generatedContent, previewMode }) => {
  if (!generatedContent || !generatedContent.content || generatedContent.content.length === 0) {
    return null;
  }

  const { title, content } = generatedContent;
  const numColumns = content.length;

  const renderColumn = (column, index) => (
    <div key={index} className="multi-column-item">
      {column.image && <img src={column.image} alt={column.columnTitle || `Column ${index + 1}`} className="multi-column-image" />}
      {column.columnTitle && <h3 className="multi-column-title">{column.columnTitle}</h3>}
      {Array.isArray(column.content) ? (
        <ul className="multi-column-list">
          {column.content.map((item, i) => <li key={i}>{item}</li>)}
        </ul>
      ) : (
        column.content && <p className="multi-column-text">{column.content}</p>
      )}
    </div>
  );

  const containerClassName = `multi-column-container columns-${numColumns}`;

  if (previewMode) {
    return (
      <div>
        <h2>{title}</h2>
        <div className={containerClassName}>
          {content.map(renderColumn)}
        </div>
      </div>
    );
  }

  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">{title}</div>
      </div>
      <div className="section-content">
        <div className={containerClassName}>
          {content.map(renderColumn)}
        </div>
      </div>
    </div>
  );
};

export default MultiColumnSection;
